<template>
  <nav
    class="pagination is-small is-rounded"
    role="navigation"
    aria-label="pagination"
  >
    <ul v-if="currentSize != -1 && items.length > 1" class="pagination-list">
      <li v-for="item of items" :key="item">
        <a
          class="pagination-link"
          :class="{ 'is-current': selected == item }"
          @click="$emit('change', item)"
          >{{ item }}</a
        >
      </li>
    </ul>

    <div
      v-if="hasOptions"
      ref="selector"
      class="margin-right-10 dropdown is-up"
      :class="{ 'is-active': visible }"
    >
      <div class="dropdown-trigger">
        <button
          class="button is-small is-white"
          aria-haspopup="true"
          aria-controls="dropdown-menu"
          @click="toggle()"
        >
          <span
            >{{
              currentSize == -1
                ? "All items on one page"
                : currentSize + " items per page"
            }}
          </span>
          <span class="icon is-small">
            <i
              :class="{
                'mdi mdi-chevron-down': !visible,
                'mdi mdi-chevron-up': visible,
              }"
              aria-hidden="true"
            ></i>
          </span>
        </button>
      </div>
      <div class="dropdown-menu" id="dropdown-menu" role="menu">
        <div class="dropdown-content">
          <a
            @click="select(5)"
            class="dropdown-item"
            :class="{ 'is-active': currentSize == 5 }"
          >
            5
          </a>
          <a
            @click="select(10)"
            class="dropdown-item"
            :class="{ 'is-active': currentSize == 10 }"
          >
            10
          </a>
          <a
            @click="select(15)"
            class="dropdown-item"
            :class="{ 'is-active': currentSize == 15 }"
          >
            15
          </a>
          <a
            @click="select(20)"
            class="dropdown-item"
            :class="{ 'is-active': currentSize == 20 }"
          >
            20
          </a>
          <a
            @click="select(25)"
            class="dropdown-item"
            :class="{ 'is-active': currentSize == 25 }"
          >
            25
          </a>
          <a
            @click="select(30)"
            class="dropdown-item"
            :class="{ 'is-active': currentSize == 30 }"
          >
            30
          </a>
          <a
            @click="select(50)"
            class="dropdown-item"
            :class="{ 'is-active': currentSize == 50 }"
          >
            50
          </a>

          <a
            @click="select(100)"
            class="dropdown-item"
            :class="{ 'is-active': currentSize == 100 }"
          >
            100
          </a>
          <a
            v-if="hasOptionAll"
            @click="select(-1)"
            class="dropdown-item"
            :class="{ 'is-active': currentSize == -1 }"
          >
            All
          </a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    items: Array,
    selected: Number,
    size: Number,
    hasOptionAll: Boolean,
    hasOptions: Boolean,
    autosave: String,
  },
  data() {
    return {
      visible: false,
      currentSize: this.size || 15,
    };
  },
  methods: {
    select(size) {
      this.currentSize = size;
      this.$emit("size", size);
      this.toggle();

      if (this.autosave) {
        this.$store.dispatch("settings/setUser", {
          path: this.autosave,
          key: "paging",
          value: { max: size },
        });
      }
    },

    toggle() {
      if (this.visible) {
        this.visible = false;
        document.removeEventListener("click", this.outsideClick);
      } else {
        this.visible = true;
        document.addEventListener("click", this.outsideClick);
      }
    },
    outsideClick(event) {
      let ddl = this.$refs["selector"];
      if (!ddl.contains(event.target)) {
        this.visible = false;
        document.removeEventListener("click", this.outsideClick);
      }
    },
  },
};
</script>
